/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-05-06 17:16:28
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-13 11:44:28
 * @FilePath: \website\src\components\dataV\attrs\cpt-dataV-border-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import defaultColor from "@/components/color";

export default {
    attribute: {
        borderType: 'dv-border-box-7',
        borderColor1: defaultColor[0],
        borderColor2: defaultColor[1],
        backgroundColor: '#00000000',
        switchGrid: false,
        borderTitle: '标题1',
        titleWidth: 250, //样式11特殊配置
        dur: 3,
        reverse: false, //样式8特殊配置
        isCloseBtn: false,
        popAlign: 'screen',
        zIndex: 2,
        bgColor: 'rgba(0, 0, 0, 0)',
        brColor: '#fff',
        activeBgColor: 'rgba(38, 132, 255, 0)',
        activeBrColor: '#2684ff',
        activeBg: '#fff',
        top:0,
        left:0,
        borderRadius:0,
        mouseTop:0,
        mouseLeft:0,
        isCloseOther:false,
        isOverlay:true,
        popAlignMouse:'centertop',
        popAlignScreen:'center',
        overlayColor:'rgba(0, 0, 0, 0.5)',
        selfBorderColor: 'rgba(0, 0, 0, 0.5)',
        selfBorderRadius: 0,
        selfBorderSize: 1,
        isSelfBorder: false,
        selfBgColor: 'rgba(0, 0, 0, 0.5)',
    },
}